<body>
    <div class="header">
        <span>
            <a href="/#/inicio"><img src="/assets/images/generico/logo.png" class="logo"></a>
        </span>
      </div>
    <div class="container mat_step_container" *ngIf="!mostrar_solicitud">

        <div class="row">
            <div class="col-md-2"></div>
            <div class="col-md-8">
                <mat-card class="example-card">
                    <mat-card-header align="center">
                        <div class="row" style="width: 100%; height: 150px; margin-bottom: 3%;">
                            <!-- <div class="col-xs-12 imgsol">
                                <img src="assets/images/titulosolcert.png" alt="">
                            </div> -->

                            <!--  <div class="col-lg-12 col-md-12 col-xs-12 imgdocs2" style="width: 100%;">
                                <img style="width: 100%; height: fit-content;" src="assets/images/exps2.jpg" alt="">
                            </div> -->
                            <!-- *ngIf="vista_copia" -->
                            <div class="title1" *ngIf="tipo_solicitud=='Copia'">
                                <h2 class="text-align-center title-section" mat-dialog-title>Solicitud de Copia de documentos y planos
                                    aprobados</h2>
                            </div>

                            <!-- *ngIf="!vista_copia" -->
                            <div class="title1" *ngIf="tipo_solicitud=='Resoluciones'">
                                <h2 class="text-align-center title-section" mat-dialog-title>Solicitud de Resoluciones de Vivienda Social
                                </h2>
                            </div>
                            <hr style="width: 90%;">
                        </div>
                    </mat-card-header>


                    <mat-card-content>

                        <table class="table-cert">
                            <tr class="tr-title" style="background-color: lightgray;">
                                <td>
                                    <p class="table_title">Nombre Solicitud</p>
                                </td>
                                <td>
                                    <p class="table_title">Valor referencial</p>
                                </td>
                                <td>
                                    <p class="table_title">Plazo de entrega</p>
                                </td>
                            </tr>
                            <!-- *ngIf="vista_copia" -->
                            <tr class="tr-info-ult" *ngIf="tipo_solicitud=='Copia'">
                                <td>
                                    COPIA DE DOCUMENTOS Y PLANOS APROBADOS
                                </td>
                                <td>
                                    ${{ valores_cert ? valores_cert.valor_cdpa : 0 }}
                                </td>
                                <td>
                                    Será enviado a su correo en hasta siete días hábiles
                                </td>
                            </tr>
                            <!-- *ngIf="!vista_copia" -->
                            <tr class="tr-info" *ngIf="tipo_solicitud=='Resoluciones'">
                                <td>
                                    RESOLUCIÓN PARA ACOGER UNA VIVIENDA AL DFL 2 DE 1959
                                </td>
                                <td>
                                    ${{ valores_cert ? valores_cert.valor_ravs : 0 }}
                                </td>
                                <td>
                                    Será enviado a su correo en hasta siete días hábiles
                                </td>
                            </tr>
                            <!-- *ngIf="!vista_copia" -->
                            <tr class="tr-info-ult" *ngIf="tipo_solicitud=='Resoluciones'">
                                <td>
                                    RESOLUCIÓN PARA CALIFICAR Y ACOGER UNA VIVIENDA SOCIAL AL DL 2552 DE 1979
                                </td>
                                <td>
                                    ${{ valores_cert ? valores_cert.valor_rcavs : 0 }}
                                </td>
                                <td>
                                    Será enviado a su correo en hasta siete días hábiles
                                </td>
                            </tr>
                        </table>

                        <div style="display: flex; padding: 10px">

                            <span class="example-spacer"></span>
                            <button class="btn_center button-special-pa" mat-raised-button 
                            (click)="solicitar_Certificados()">Continuar</button>
                        </div>

                    </mat-card-content>
                </mat-card>
            </div>
            <div class="col-md-2"></div>

        </div>
    </div>


    <div class="container mat_step_container" *ngIf="mostrar_solicitud">
        <!-- <div class="row" align="right">
            <button class="btn_danger" mat-button (click)="cerrar_vista()">Salir</button>
        </div> -->
        <div class="row" style="width: 100%; height: 150px;">
            <!-- *ngIf="vista_copia" -->
            <div class="title1" *ngIf="tipo_solicitud=='Copia'">
                <h2 class="text-align-center title-section" mat-dialog-title> Solicitud de Copia de documentos y planos aprobados</h2>
            </div>

            <!-- *ngIf="!vista_copia" -->
            <div class="title1" *ngIf="tipo_solicitud=='Resoluciones'">
                <h2 class="text-align-center title-section" mat-dialog-title>Solicitud de Resoluciones de Vivienda Social</h2>
            </div>
        </div>

        <div>

            <mat-card class="example-card">

                <mat-card-content>

                    <mat-horizontal-stepper class="container-stepper" #stepper>
                        <mat-step [stepControl]="firstFormGroup">
                            <form [formGroup]="firstFormGroup">
                                <ng-template matStepLabel>Datos personales</ng-template>
                                <div class="row" *ngIf="!modificando">
                                    <div class="col-lg-12 col-sm-12 col-xs-12 col-md-12 contbuscar"
                                        style="margin-left: 5%">
                                        <p>Ingrese su rut</p>
                                        <mat-form-field>
                                            <input matInput placeholder="Rut" formControlName="rut">

                                            <mat-error *ngIf="firstFormGroup.controls.rut.hasError('minlength')">
                                                Este campo debe tener <strong>más de 8 caracteres</strong>.
                                            </mat-error>
                                        </mat-form-field>


                                        <button mat-raised-button color="primary"
                                            [disabled]="!firstFormGroup.controls.rut.valid"
                                            (click)="buscar_info_sol()">Buscar</button>
                                    </div>

                                </div>
                                <div class="container_info_rut" *ngIf="primerPaso">
                                    <div class="row">
                                        <p class="title_datos"><strong>Datos solicitante</strong></p>
                                    </div>
                                    <div class="container_info_rut2">
                                        <div class="row" style="padding-bottom: 20px">


                                            <div class="col-lg-2 col-md-2 col-sm-2 name_info">
                                                <p>RUT:</p>
                                            </div>


                                            <div class="col-lg-3 col-md-3 col-sm-3 view_info">
                                                {{ info_rut.rut }}
                                            </div>


                                            <div
                                                class="col-lg-2 col-md-2 col-sm-2 col-lg-offset-1 col-md-offset-1 col-sm-offset-1 name_info">
                                                <p>Solicitante:</p>
                                            </div>
                                            <div class="col-lg-3 col-md-3 col-sm-3 view_info">
                                                {{ info_rut.nombre }} {{ info_rut.apellido_p}} {{ info_rut.apellido_m}}
                                            </div>




                                            <hr class="col-lg-10 col-md-10 col-sm-10" />

                                        </div>
                                        <div class="row" style="padding-bottom: 20px">


                                            <!-- class="col-lg-2 col-md-2 col-sm-2 col-lg-offset-1 col-md-offset-1 col-sm-offset-1 name_info" -->
                                            <div class="col-lg-2 col-md-2 col-sm-2 name_info">
                                                <p>Teléfono:</p>
                                            </div>

                                            <div class="col-lg-3 col-md-3 col-sm-3 view_info">
                                                {{ info_rut.telefono }}
                                            </div>



                                            <div
                                                class="col-lg-2 col-md-2 col-sm-2 col-lg-offset-1 col-md-offset-1 col-sm-offset-1 name_info">
                                                <p>Celular:</p>
                                            </div>
                                            <div class="col-lg-3 col-md-3 col-sm-3 view_info">
                                                {{ info_rut.celular }}
                                            </div>
                                            <hr class="col-lg-10 col-md-10 col-sm-10" />
                                        </div>



                                        <div class="row" style="padding-bottom: 20px">
                                            <!-- col-lg-2 col-md-2 col-sm-2 col-lg-offset-1 col-md-offset-1 col-sm-offset-1 name_info -->
                                            <div class="col-lg-2 col-md-2 col-sm-2 name_info">
                                                <p>Email:</p>
                                            </div>
                                            <div class="col-lg-3 col-md-3 col-sm-3 view_info">
                                                {{ info_rut.email }}
                                            </div>

                                            <div *ngIf="false"
                                                class="col-lg-2 col-md-2 col-sm-2 col-lg-offset-1 col-md-offset-1 col-sm-offset-1 name_info">
                                                <p>Región:</p>
                                            </div>

                                            <div *ngIf="false" class="col-lg-3 col-md-3 col-sm-3 view_info">
                                                {{ info_rut.region }}
                                            </div>

                                            <hr class="col-lg-10 col-md-10 col-sm-10" />
                                        </div>


                                        <div class="row" style="padding-bottom: 20px">

                                            <div class="col-lg-2 col-md-2 col-sm-2 name_info">
                                                <p>Calle:</p>
                                            </div>
                                            <div class="col-lg-3 col-md-3 col-sm-3 view_info">
                                                {{ info_rut.calle }}
                                            </div>


                                            <div
                                                class="col-lg-2 col-md-2 col-sm-2 col-lg-offset-1 col-md-offset-1 col-sm-offset-1 name_info">
                                                <p>Número:</p>
                                            </div>
                                            <div class="col-lg-3 col-md-3 col-sm-3 view_info">
                                                {{ info_rut.numero }}
                                            </div>




                                            <hr class="col-lg-10 col-md-10 col-sm-10" />
                                        </div>
                                        <div class="row" style="padding-bottom: 20px">

                                            <div class="col-lg-2 col-md-2 col-sm-2 name_info">
                                                <p>Comuna:</p>
                                            </div>
                                            <div class="col-lg-3 col-md-3 col-sm-3 view_info">
                                                {{ info_rut.comuna }}
                                            </div>

                                            <div
                                                class="col-lg-2 col-md-2 col-sm-2 col-lg-offset-1 col-md-offset-1 col-sm-offset-1 name_info">
                                                <p>Complemento:</p>
                                            </div>
                                            <div class="col-lg-3 col-md-3 col-sm-3 view_info">
                                                {{ info_rut.complemento }}
                                            </div>








                                            <hr class="col-lg-10 col-md-10 col-sm-10" />
                                        </div>
                                    </div>
                                    <div *ngIf="!continuar" class="col-md-12 col-sm-12 col-lg-12 col-xs-12 error-mail">
                                        <p>El mail es obligatorio, favor modificar su usauario e ingresar un mail
                                            valido.
                                        </p>
                                    </div>
                                </div>
                                <div formGroupName="mod_solicitante" class="container_info_rut" *ngIf="modificando">
                                    <div class="row title_mod_div" *ngIf="rut_encontrado">
                                        <strong>
                                            <p class="title_mod">Modificando Datos del solicitante</p>
                                        </strong>
                                    </div>
                                    <div class="row title_mod_div" *ngIf="!rut_encontrado">
                                        <strong>
                                            <p class="title_mod">Registrando Datos del solicitante</p>
                                        </strong>

                                    </div>


                                    <div class="row">


                                        <div class="col-lg-6 col-md-6 col-sm-6">

                                            <label for="nombre" class="col-md-3 mt5">Nombre(<span
                                                    style="color:red;">*</span>)</label>
                                            <!-- <p class="title_info">Nombre *</p> -->
                                            <mat-form-field>
                                                <input matInput formControlName="nombre">
                                            </mat-form-field>
                                        </div>






                                        <div class="col-lg-6 col-md-6 col-sm-6">
                                            <label for="telefono" class="col-md-3 mt5">Telefono</label>
                                            <!-- <p class="title_info">Teléfono </p> -->

                                            <mat-form-field>
                                                <input matInput formControlName="telefono" inputmode=”numeric”
                                                    pattern="[0-9]*" placeholder="Tel&eacute;fono" maxlength="9">
                                                <mat-error
                                                    *ngIf="firstFormGroup.controls.mod_solicitante.controls.telefono.hasError('pattern')">
                                                    Solo se permiten caracteres <strong>numéricos</strong>
                                                </mat-error>
                                                <mat-error
                                                    *ngIf="firstFormGroup.controls.mod_solicitante.controls.telefono.hasError('minlength')">
                                                    Este campo debe tener <strong>más de 8 caracteres</strong>.
                                                </mat-error>

                                            </mat-form-field>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-6 col-md-6 col-sm-6">

                                            <label for="apellido_p" class="col-md-3 mt5">Apellido Paterno</label>

                                            <!-- <p class="title_info">Apellido Paterno</p> -->
                                            <mat-form-field>
                                                <input matInput formControlName="apellido_p">
                                            </mat-form-field>
                                        </div>
                                        <div class="col-lg-6 col-md-6 col-sm-6">
                                            <label for="cel" class="col-md-3 mt5">Celular (<span
                                                    style="color:red;">*</span>)</label>
                                            <!-- <p class="title_info">Celular *</p> -->
                                            <mat-form-field>
                                                <input matInput formControlName="cel">
                                                <mat-error
                                                    *ngIf="firstFormGroup.controls.mod_solicitante.controls.cel.hasError('pattern')">
                                                    Solo se permiten caracteres <strong>numéricos</strong>
                                                </mat-error>
                                                <mat-error
                                                    *ngIf="firstFormGroup.controls.mod_solicitante.controls.cel.hasError('minlength')">
                                                    Este campo debe tener <strong>más de 8 caracteres</strong>.
                                                </mat-error>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                    <div class="row">

                                        <!-- Apellido Materno -->
                                        <div class="col-lg-6 col-md-6 col-sm-6">

                                            <label for="apellido_m" class="col-md-3 mt5">Apellido Materno</label>

                                            <!-- <p class="title_info">Apellido Materno</p> -->

                                            <mat-form-field>
                                                <input matInput formControlName="apellido_m">
                                            </mat-form-field>
                                        </div>



                                        <!-- Email -->
                                        <div class="col-lg-6 col-md-6 col-sm-6">
                                            <label for="email" class="col-md-3 mt5">Email (<span
                                                    style="color:red;">*</span>)</label>
                                            <!-- <p class="title_info">Email *</p> -->
                                            <mat-form-field>
                                                <input matInput formControlName="email">
                                            </mat-form-field>
                                        </div>



                                    </div>

                                    <div class="row">
                                        <!-- Calle -->
                                        <div class="col-lg-6 col-md-6 col-sm-6">
                                            <label for="calle" class="col-md-3 mt5">Calle (<span
                                                    style="color:red;">*</span>)</label>
                                            <!-- <p class="title_info">Calle *</p> -->
                                            <mat-form-field>
                                                <input matInput formControlName="calle">
                                            </mat-form-field>
                                        </div>


                                        <!-- Numero -->
                                        <div class="col-lg-6 col-md-6 col-sm-6">
                                            <label for="num" class="col-md-3 mt5">Número</label>
                                            <!-- <p class="title_info">Número *</p> -->
                                            <mat-form-field>
                                                <input matInput formControlName="num">
                                            </mat-form-field>
                                        </div>





                                    </div>





                                    <div class="row">





                                        <!-- Región -->
                                        <div class="col-lg-6 col-md-6 col-sm-6">

                                            <!-- <div *ngIf="showSpinnerRegiones">
                                                <label>Cargando Regiones ... </label>
                                                <mat-spinner diameter="20"></mat-spinner>
                                            </div> -->


                                            <div *ngIf="!showSpinnerComunas">


                                                <label for="region" class="col-md-3 mt5">Region (<span
                                                        style="color:red;">*</span>)</label>
                                                <!-- <mat-progress-bar mode="indeterminate" *ngIf="showSpinnerRegiones">
                                            </mat-progress-bar> -->
                                                <select class="form-control mt5" name="region" id="region"
                                                    placeholder="región" formControlName="region"
                                                    (change)="cambiarComunas(true,null)">
                                                    <option *ngFor="let region of regiones?.data; let i = index;"
                                                        [value]="region.fieldData.region">
                                                        {{region.fieldData.region}}
                                                    </option>
                                                </select>
                                            </div>

                                        </div>
                                        <!-- Comuna -->
                                        <div class="col-lg-6 col-md-6 col-sm-6">
                                            <div *ngIf="showSpinnerComunas">
                                                <label>Cargando Regiones y Comunas ... </label>
                                                <mat-spinner diameter="20"></mat-spinner>
                                            </div>
                                            <!-- <mat-progress-bar mode="indeterminate" *ngIf="showSpinnerComunas">
                                            </mat-progress-bar> -->


                                            <div *ngIf="!showSpinnerComunas">
                                                <label for="comuna" class="col-md-3 mt5">Comuna (<span
                                                        style="color:red;">*</span>)</label>
                                                <!-- <mat-progress-bar mode="indeterminate" *ngIf="showSpinnerComunas">
                                                </mat-progress-bar>
                                                <label *ngIf="showSpinnerComunas">Seleccione región</label> -->
                                                <select matTooltip="Comunas se actualizan al cambiar la Región" (change)="seleccionComuna()" class="form-control mt5" name="comuna" id="comuna"
                                                    [disabled]="comunasFinal?.length == 0" formControlName="comuna">
                                                    <option [disabled]="false" selected *ngIf="!comunaSelected">
                                                        Seleccionar</option>
                                                    <option *ngFor="let comuna of comunasFinal; let i = index;" >
                                                        {{comuna.fieldData.COM_Nombre}}</option>
                                                </select>
                                            </div>
                                        </div>


                                    </div>



                                    <div class="row">
                                        <div class="col-lg-6 col-md-6 col-sm-6">
                                            <label for="complemento" class="col-md-3 mt5">Complemento</label>
                                            <!-- <p class="title_info">Complemento</p> -->
                                            <mat-form-field>
                                                <input matInput formControlName="complemento">
                                            </mat-form-field>
                                        </div>
                                    </div>

                                </div>

                                <div *ngIf="!modificando" class="row" style="padding: 0px">
                                    <div class="col-lg-6 col-md-6 col-sm-6">
                                        <button mat-raised-button color="primary" (click)="mod_inforut()"
                                            [disabled]="!rut_encontrado">Modificar</button>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-6" align="right">
                                        <button mat-raised-button color="primary" matStepperNext
                                            [disabled]="!primerPaso || !continuar || !emailValido">Continuar</button>
                                    </div>
                                </div>
                                <div *ngIf="modificando" class="col-md-12" style="padding: 0px">
                                    <div class="col-lg-6 col-md-6 col-sm-6" align="left" style="padding: 0px">
                                        <button class="btn_danger" mat-raised-button
                                            (click)="cancelar_mod()">Cancelar</button>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-6" *ngIf="rut_encontrado" align="right"
                                        style="padding: 0px">
                                        <p *ngIf="!firstFormGroup.valid || !comunaSelected" ><span style="color: red">Selecciona los campos<strong> requeridos</strong></span></p>
                                        <button [disabled]="!firstFormGroup.valid || !comunaSelected" mat-raised-button color="primary"
                                            (click)="guarda_mod()"> Guardar</button>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-6" *ngIf="!rut_encontrado" align="right"
                                        style="padding: 0px">
                                        <button mat-raised-button color="primary" (click)="registro_sol()"
                                            [disabled]="!firstFormGroup.valid">Registrar</button>
                                    </div>
                                </div>
                            </form>
                        </mat-step>

                        <mat-step [stepControl]="secondFormGroup">
                            <form [formGroup]="secondFormGroup">
                                <ng-template matStepLabel>Identificación</ng-template>
                                <div class="row">
                                    <div class="col-lg-12">
                                        <strong>
                                            <p class="title_datos">Ingrese las direcciones(Máximo de 3 direcciones)</p>
                                        </strong>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-12 col-md-12 col-sm--12 div_rol">
                                        <p>Rol</p>
                                        <mat-form-field class="mat-field-calle">
                                            <input class="mat_input" matInput placeholder="(ej: 279-10)"
                                                [formControl]="rol">
                                            <button mat-button style="margin: 0px;"
                                                *ngIf="secondFormGroup.controls.rol.value" matSuffix mat-icon-button
                                                aria-label="Clear" (click)="secondFormGroup.controls?.rol.setValue('')">
                                                <mat-icon>close</mat-icon>
                                            </button>
                                        </mat-form-field>
                                        <button mat-raised-button color="primary" (click)="buscar_info_propiedad_rol()"
                                            [disabled]="!rol.valid ||  !secondFormGroup.controls.rol.value">Buscar por
                                            Rol <i class="material-icons">search</i></button>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="ccol-lg-12 col-md-12 col-sm--12 div_dir">
                                        <p>Dirección</p>
                                        <mat-form-field class="mat-field-calle">
                                            <input matInput type="text" placeholder="Calle" formControlName="dir"
                                                [matAutocomplete]="auto">
                                            <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
                                                <mat-option *ngFor="let option of filteredOptions | async"
                                                    [value]="option">
                                                    {{option}}
                                                </mat-option>
                                            </mat-autocomplete>
                                            <button mat-button style="margin: 0px;"
                                                *ngIf="secondFormGroup.controls?.dir.value" matSuffix mat-icon-button
                                                aria-label="Clear" (click)="secondFormGroup.controls?.dir.setValue('')">
                                                <mat-icon>close</mat-icon>
                                            </button>
                                        </mat-form-field>
                                        <mat-form-field class="mat-field-calle">
                                            <input class="mat_input" matInput placeholder="Número" [formControl]="num">
                                            <button mat-button style="margin: 0px"
                                                *ngIf="secondFormGroup.controls?.num.value" matSuffix mat-icon-button
                                                aria-label="Clear" (click)="secondFormGroup.controls?.num.setValue('')">
                                                <mat-icon>close</mat-icon>
                                            </button>
                                        </mat-form-field>


                                        <button mat-raised-button color="primary"
                                            (click)="buscar_info_propiedad_direccion()"
                                            [disabled]="!num.valid || !dir.valid || !secondFormGroup.controls.dir.value ">Buscar
                                            por Dirección <i class="material-icons">search</i></button>
                                    </div>
                                </div>
                                <div class="row" style="padding-top: 40px; padding-bottom: 30px;">
                                    <div class="col-lg-12">
                                        <table class="col-md-12" mat-table [dataSource]="lista_dir"
                                            class="mat-elevation-z8">

                                            <ng-container matColumnDef="rol">
                                                <th mat-header-cell *matHeaderCellDef style="width: 30%">
                                                    <strong>Rol</strong>
                                                </th>
                                                <td mat-cell *matCellDef="let element"> {{element.rol}} </td>
                                            </ng-container>

                                            <ng-container matColumnDef="direccion">
                                                <th mat-header-cell *matHeaderCellDef style="width: 60%">
                                                    <strong>Nombre</strong>
                                                </th>
                                                <td mat-cell *matCellDef="let element"> {{element.calle}} N
                                                    {{element.num}}
                                                </td>
                                            </ng-container>

                                            <ng-container matColumnDef="actions">
                                                <th mat-header-cell *matHeaderCellDef style="width: 10%">
                                                    <strong>Opción</strong>
                                                </th>
                                                <td mat-cell *matCellDef="let element; let i = index"><button
                                                        mat-raised-button color="primary"
                                                        (click)="eliminar_direccion(i)">Eliminar</button></td>
                                            </ng-container>

                                            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                                        </table>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-6 col-md-6 col-sm-6" align="left">
                                        <button class="btn_l" mat-raised-button color="primary"
                                            matStepperPrevious>Volver</button>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-6" align="right">
                                        <button class="btn_r" mat-raised-button color="primary" matStepperNext
                                            [disabled]="!segundoPaso" (click)="direccioness()">Continuar</button>
                                    </div>
                                </div>
                            </form>
                        </mat-step>
                        <!-- *ngIf="!vista_copia"  -->
                        <mat-step *ngIf="tipo_solicitud=='Resoluciones'">
                            <form [formGroup]="thirdFormGroup">
                                <ng-template matStepLabel>Selección</ng-template>
                                <div class="row">
                                    <div class="col-lg-12" style="margin-left: 1%">
                                        <strong>
                                            <p class="title_datos">Seleccione las solicitudes que desee para cada
                                                propiedad</p>
                                        </strong>
                                    </div>
                                </div>
                                <div class="data" *ngFor="let item of dirs; let i = index">
                                    <div class="row">
                                        <div class="col-lg-12">
                                            <p class="title_info">Rol {{ item.rol }}, {{ item.calle }} {{ item.num }}
                                            </p>
                                        </div>
                                    </div>
                                    <div class="row checks" *ngFor="let certs of certificados; let o = index">
                                        <div class="col-lg-12">
                                            <mat-checkbox MatCheckboxChange class="example-margin" [value]="certs.cert"
                                                (change)="someFunction(i,item, $event)" [checked] #myCheckbox>
                                                {{ certs.nombre_completo }}</mat-checkbox>
                                        </div>
                                    </div>
                                    <hr class="col-lg-12" />
                                </div>
                                <div class="row">
                                    <div class="col-lg-6 col-md-6 col-sm-6" align="left">
                                        <button mat-raised-button color="primary" matStepperPrevious>Volver</button>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-6" align="right">
                                        <button mat-raised-button color="primary" matStepperNext
                                            [disabled]="!cert_seleccionado"
                                            (click)="calcular_total()">Continuar</button>
                                    </div>
                                </div>
                            </form>
                        </mat-step>

                        <!-- *ngIf="vista_copia"   -->
                        <mat-step *ngIf="tipo_solicitud=='Copia'">
                            <ng-template matStepLabel>Información adicional</ng-template>
                            <div>

                                <div class="row">
                                    <strong>
                                        <p class="title_datos">Ingreso de información adicional</p>
                                    </strong>
                                </div>

                                <div class="row" *ngFor="let item of dirs; let i = index">
                                    <div class="col-lg-12 col-md-12 col-sm-12">
                                        <p class="title_info">{{ item.rol }}, {{ item.calle}} Nº {{ item.num }}</p>
                                    </div>
                                    <!-- *ngIf='vista_copia' -->
                                    <div class="row cert_select_info" *ngIf="item.cdpa && tipo_solicitud=='Copia'"
                                        style="display: flex; margin-right: 0px;">


                                        <div class="col-lg-5 col-md-5 col-sm-5">
                                            <p><i class="material-icons">description</i>COPIA DE DOCUMENTOS Y PLANOS
                                                APROBADOS
                                            </p>
                                        </div>

                                        <!-- <b>
                                        Junto con esta solicitud es necesario que
                                        ingrese la información solicitada en
                                    </b> -->
                                        <span class="example-spacer"></span>
                                        <button mat-raised-button color="primary"
                                            (click)="openIngresogiro(item.rol,i)">Ingresar información</button>

                                    </div>

                                    <!-- vista_copi' -->
                                    <div class="row cert_select_info" *ngIf="!item.cdpa && tipo_solicitud=='Copia'">
                                        <div class="col-lg-5 col-md-5 col-sm-5">
                                        </div>
                                        <p>
                                            No hay información adicional para agregar a esta solicitud.
                                        </p>
                                    </div>
                                    <hr class="col-lg-12" />
                                </div>
                                <!--   copiaDocsBandera: {{copiaDocsBandera}} -->
                                <div class="row" style="padding: 0px; display:flex">
                                    <!-- <div class="col-lg-6 col-md-6 col-sm-6" align="left"> -->
                                    <button mat-raised-button color="primary" matStepperPrevious>Volver</button>
                                    <!-- </div> -->

                                    <span class="example-spacer"></span>

                                    <!-- <div class="col-lg-6 col-md-6 col-sm-6 " align="right"> -->

                                    <button matStepperNext mat-raised-button color="primary"
                                        [disabled]="!copiaDocsBandera">Continuar</button>
                                    <!-- matStepperNext -->

                                    <!-- </div> -->
                                </div>
                            </div>
                        </mat-step>


                        <mat-step>
                            <ng-template matStepLabel>Confirmación</ng-template>
                            <!-- <div class="container"> -->
                            <div class="row">
                                <strong>
                                    <p class="title_datos">Detalle lista de propiedades:</p>
                                </strong>
                            </div>
                            <div class="row" *ngFor="let item of dirs">
                                <div class="col-lg-12 col-md-12 col-sm-12">
                                    <p class="title_info">{{ item.rol }}, {{ item.calle}} Nº {{ item.num }}</p>
                                </div>
                                <div class="row cert_select_info">

                                    <div class="col-lg-5 col-md-5 col-sm-5">


                                        <p *ngIf="tipo_solicitud=='Copia'"><i
                                                class="material-icons">description</i>COPIA DE DOCUMENTOS Y PLANOS
                                            APROBADOS
                                        </p>
                                        <!-- esconder? -->

                                        <div *ngIf="item.copia">
                                            <p> <b> Copia:</b></p>
                                            <li *ngFor="let copia of item.copia"> {{copia}} </li>
                                        </div>
                                        <div *ngIf="item.fotocopia">
                                            <p><b>Fotocopia:</b></p>
                                            <li *ngFor="let fotocopia of item.fotocopia"> {{fotocopia}} </li>
                                        </div>
                                        <div *ngIf="item.tamano">
                                            <p><b>Tamaño:</b> {{item.tamano}} </p>
                                        </div>
                                        <div *ngIf="item.firma">
                                            <p><b>Firma: </b>{{item.firma}} </p>
                                        </div>
                                        <div *ngIf="item.observaciones">
                                            <p><b>Observaciones:</b> {{item.observaciones}} </p>
                                        </div>

                                    </div>
                                </div>
                                <!-- !vista_copia -->
                                <div class="row cert_select_info" *ngIf="item.ravs  && tipo_solicitud=='Resoluciones'">
                                    <div class="col-lg-5 col-md-5 col-sm-5">
                                        <p><i class="material-icons">description</i>RESOLUCIÓN PARA ACOGER UNA
                                            VIVIENDA
                                            AL
                                            DFL 2 DE 1959</p>
                                    </div>
                                    <div
                                        class="col-lg-1 col-md-1 col-sm-1 col-lg-offset-5 col-md-offset-5 col-sm-offset-5">
                                        <p>${{valores_cert.valor_ravs }}</p>
                                    </div>
                                </div>
                                <!--  !vista_copia -->
                                <div class="row cert_select_info" *ngIf="item.rcavs && tipo_solicitud=='Resoluciones'">
                                    <div class="col-lg-5 col-md-5 col-sm-5">
                                        <p><i class="material-icons">description</i>RESOLUCIÓN PARA CALIFICAR Y
                                            ACOGER
                                            UNA
                                            VIVIENDE SOCIAL AL DL 2552 DE 1979</p>
                                    </div>
                                    <div
                                        class="col-lg-1 col-md-1 col-sm-1 col-lg-offset-5 col-md-offset-5 col-sm-offset-5">
                                        <p>${{valores_cert.valor_rcavs }}</p>
                                    </div>
                                </div>
                                <hr class="col-lg-12" />
                            </div>
                            <div class="row">
                                <div class="col-lg-12" *ngIf="primerPaso" style="padding-bottom: 20px;">
                                    <strong>
                                        <p style="text-align: center; padding: 0 24px 24px 24px;">
                                            <!-- Recibirá un correo electrónico a << {{ info_rut.email }}>> con el
                                                    comprobante de su solicitud. <br>Se sugiere revisar el pago
                                                    efectuado en
                                                    su
                                                    banco. -->
                                            Le llegará una confirmación de su solicitud al

                                            siguiente
                                            correo electrónico:
                                            {{ info_rut.email }}
                                        </p>
                                    </strong>
                                </div>
                                <div class="col-lg-12">
                                    <strong>
                                        <!-- !vista_copia -->
                                        <p style="text-align: center;" *ngIf="tipo_solicitud=='Resoluciones'">
                                            El valor referencial a pagar en
                                            el momento de retiro es de: ${{ mostrar_total }}</p>
                                    </strong>
                                </div>
                            </div>


                            <div class="contenedor"> </div>
                            <div class="row">

                                <div class="row info_pagar">
                                    <div class="col-lg-12 col-md-12 col-sm-12" style="padding-bottom: 20px">

                                        <!--   *ngIf="!vista_copia" -->
                                        <p *ngIf="tipo_solicitud=='Resoluciones'">
                                            Para completar su solicitud de Calificación y Valorización, enviar el
                                            Certificado de Avalúo Fiscal detallado (SII) <br> al correo
                                            Katty.marin@mpuentealto.cl indicando el numero de ingreso.

                                            <!-- Para finalizar, deberá presionar el botón
                                        "finalizar", se le enviará un correo con las indicaciones con el plazo para el
                                        retiro.  -->

                                        </p>
                                        <!-- *ngIf="vista_copia" -->
                                        <p *ngIf="tipo_solicitud=='Copia'">
                                            Para completar su solicitud de copia de documentos y planos, enviar la
                                            declaración del propietario a claudia.fernandois@mpuentealto.cl indicando el
                                            numero de ingreso.

                                        </p>
                                    </div>
                                    <div class="col-lg-12 col-md-12 col-sm-12" style="padding-bottom: 20px">
                                        <p style="text-align: center;">
                                            <!-- En caso de dudas o consultas, debe comunicarse con el Departamento de Vivienda
                                        Social de la Dirección de Obras Municipales.
                                     -->
                                            Consultas: lindsay.avila@mpuentealto.cl

                                        </p>

                                    </div>
                                    <div class="col-lg-12 col-md-12 col-sm-12">
                                        <p style="text-align: center;">
                                            Municipalidad de Puente Alto - Dirección de Obras
                                        </p>

                                    </div>
                                    <div class="col-lg-12 col-md-12 col-sm-12">
                                        <p style="text-align: center;">
                                            Av. Concha y Toro 1820, Puente Alto, Santiago - Teléfono : +56228101600
                                        </p>
                                    </div>
                                    <div class="col-lg-12 col-md-12 col-sm-12">
                                        <p style="text-align: center;"><a [href]="link" target="_blank">{{
                                                nombreLink
                                                }}</a>
                                        </p>
                                    </div>
                                </div>
                            </div>



                            <!-- </div> -->



                            <div>
                                <div class="col-lg-6 col-md-6 col-sm-6" align="left">
                                    <button mat-raised-button color="primary" matStepperPrevious>Volver</button>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-6" align="right">
                                    <button type="submit" (click)="ingresoFm()" mat-raised-button color="primary"
                                        class="btn">
                                        Finalizar
                                    </button>
                                </div>

                            </div>
                        </mat-step>
                    </mat-horizontal-stepper>


                </mat-card-content>
            </mat-card>
        </div>
    </div>







</body>


<ng-template #ingresarInfo>
    <h2 mat-dialog-title>Ingreso de información para la solicitud de la Copia de Documentos y Planos Aprobados para el
        rol:
        {{ this.seleccion_rol }}</h2>
    <mat-dialog-content>
        <form [formGroup]="thirdFormGroup">

            <div class="row" style="padding-bottom: 4%">
                <div class="col-lg-9 col-md-9 col-sm-9">
                    <mat-form-field style="width: 100%;">
                        <mat-label>Observaciones</mat-label>
                        <textarea matInput placeholder="Observaciones..." formControlName="observaciones"></textarea>
                    </mat-form-field>
                </div>
            </div>

            <div class="row" style="padding-bottom: 4%;">
                <div class="col-lg-6 col-md-6 col-sm-6">
                    <mat-label>¿Necesita firma del secretario municipal? <b>(*)</b> </mat-label>
                    <mat-radio-group aria-label="Select an option" formControlName="firma" required
                        style="display: grid;">
                        <mat-radio-button value="SI">Si </mat-radio-button>
                        <mat-radio-button value="NO">No </mat-radio-button>
                    </mat-radio-group>
                </div>

                <div class="col-lg-6 col-md-6 col-sm-6">
                    <mat-label>Tamaño <b>(*)</b> </mat-label>
                    <mat-select formControlName="tamano" placeholder="Tamaño..." required>
                        <mat-option *ngFor="let tamano of tamanos" [value]="tamano.tipo_documento">
                            {{tamano.tipo_documento}}
                        </mat-option>
                    </mat-select>
                </div>
            </div>


            <div class="row" style="padding-bottom: 4%">
                <div class="col-lg-6 col-md-6 col-sm-3">
                    <mat-label>COPIA DE DOCUMENTOS </mat-label>
                    <div *ngFor="let fotocopia of fotocopias; let i=index" style="padding-bottom: 1%;">
                        <label>
                            <input type="checkbox"
                                [checked]="checkedFotocopias[seleccion_pos] && checkedFotocopias[seleccion_pos].includes(fotocopia.tipo_documento)"
                                [value]="fotocopia.tipo_documento" (change)="onCheckboxChange($event, 'fotocopia')" />
                            {{fotocopia.tipo_documento}}
                        </label>
                    </div>
                </div>

                <div class="col-lg-6 col-md-6 col-sm-6">
                    <mat-label>COPIA DE PLANOS </mat-label>
                    <div *ngFor="let plano of planos; let i=index">
                        <label>
                            <input type="checkbox"
                                [checked]="checkedCopias[seleccion_pos] && checkedCopias[seleccion_pos].includes(plano.tipo_documento)"
                                [value]="plano.tipo_documento" (change)="onCheckboxChange($event, 'copia')" />
                            {{plano.tipo_documento}}
                        </label>
                    </div>
                </div>
            </div>

            <!--      validFotocopiayCopia: {{validFotocopiayCopia}} -->
        </form>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <div *ngIf="!validFotocopiayCopia">
            <b>Seleccionar al menos una Fotocopia o una Copia para continuar.</b>
        </div>

        <button matDialogClose mat-raised-button color="primary" id="cancel_mail" data-dismiss="modal"
            (click)="limpiarDocs(); this.dialog.closeAll();">Cancelar</button>
        <button matDialogClose mat-raised-button color="warn" id="cancel_mail" data-dismiss="modal"
            [disabled]="!thirdFormGroup.valid || !validFotocopiayCopia"
            (click)="ingresarInfoAdicional()">Continuar</button>
    </mat-dialog-actions>
</ng-template>


<ng-template #ingresarInfoListo>
    <h2 mat-dialog-title>Ingreso de información para la solicitud de la Copia de Documentos y Planos Aprobados para el
        rol:
        {{ this.seleccion_rol }}</h2>
    <mat-dialog-content>

        <p>Ya no hay información por agregar para este rol.</p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button matDialogClose mat-raised-button color="primary" id="cancel_mail" data-dismiss="modal"
            (click)="this.dialog.closeAll();">Aceptar</button>
    </mat-dialog-actions>
</ng-template>


<ng-template #modalDirecciones>
    <h2 mat-dialog-title> Seleccionar dirección</h2>
    <mat-dialog-content>

        <div class="form-horizontal">
            <div class="alert alert-info" role="alert">
                <i class="fa fa-info-circle" aria-hidden="true"></i>
                <strong> Debe seleccionar una de las direcciones</strong>
            </div>
            <div id="search-box-div" style="text-align: center; padding-bottom: 5px;">
                <div id="search-field" class="top-div">
                    <input #input type="text" placeholder="Buscar" [(ngModel)]="searchText">
                </div>
            </div>
            <ul class="list-group">
                <li class="list-group-item"
                    *ngFor="let direccion of direcciones | filter: searchText | paginate: {itemsPerPage: 10, currentPage: p}">

                    <input type="radio" id="direccionSelec" name="direccionSelect" [value]="direccion" name="modal_dir"
                        [(ngModel)]="temp_dir">
                    <span>{{direccion.direccion_completa}}</span>
                </li>
            </ul>
            <div style="text-align:center">
                <pagination-controls [nextLabel]="'Siguiente'" [previousLabel]="'Anterior'" (pageChange)="p = $event">
                </pagination-controls>
            </div>
        </div>

    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button matDialogClose mat-raised-button color="warn" id="clean_ingreso_propiet" data-dismiss="modal"
            (click)="cleanData()">Cancelar</button>
        <button mat-raised-button color="primary" id="ingreso_propiet" (click)="savePropiedadMulti(temp_dir)">Ingresar
            Propiedad <i class="fa fa-user-o" aria-hidden="true"></i></button>

    </mat-dialog-actions>
</ng-template>



<ng-template #modalNotFound>
    <h2 mat-dialog-title>Información de Rol</h2>
    <mat-dialog-content>
        <div class="form-horizontal">
            <div class="form-group">
                <label class="col-md-12 control-label" for="rol">El rol no existe o no es valido</label>
            </div>
        </div>

    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button matDialogClose mat-raised-button color="warn" id="clean_ingreso_propiet" data-dismiss="modal"
            (click)="secondFormGroup.controls?.rol.setValue('')">Ok</button>
    </mat-dialog-actions>
</ng-template>